import { useState, ReactNode } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// components
import LoadingScreen from "../components/loading-screen";
//
import Login from "../pages/auth/login/LoginPage";
import { useAuthContext } from "./useAuthContext";
import {
  PATH_AFFILIATE,
  PATH_AUTH,
  PATH_DASHBOARD,
  PATH_KYC,
} from "../routes/paths";
import { TabsData } from "../utils/common";

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user, isAffiliate, isSalesUser, isAuthenticated, isInitialized } =
    useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  // Prevent affiliates and sales users from accessing MSME routes
  if (isAffiliate || isSalesUser) {
    return <Navigate to={"/404"} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children}</>;
}
